<template>
    <div id="active68">

        <div class="box">
            <div class="option" @click="active=82;show=true">
                <div class="pao">
                    充68
                </div>
                <div class="info">
                    <h3><span>送</span>88</h3>
                    <p>6800书币+8800书豆</p>
                    <button>立即领取</button>
                </div>
            </div>
            <div class="option" @click="active=83;show=true">
                <div class="pao">
                    充98
                </div>
                <div class="info">
                    <h3><span>送</span>128</h3>
                    <p>9800书币+12800书豆</p>
                    <button>立即领取</button>
                </div>
            </div>
        </div>

        <p class="tip">
            书币属于虚拟商品，一经购买不得退换。
        </p>
        <p class="tip">
            活动最终解释权归网站所有。
        </p>
        <div class="type" v-if="show" @click="show=false">
            <ul>
                <li class="wechat" :class="{active:type == 6}" @click="setType(6)">
                    <img src="http://static.yuread.cn/quick/wechat1.png" alt=""> 微信充值
                </li>
                <li class="zfb" :class="{active:type == 7}" @click="setType(7)">
                    <img src="http://static.yuread.cn/quick/zfb1.png" alt=""> 支付宝
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Active68",
        data(){
            return {
                type : 6,
                show : false,
                active : 82,

            }
        },
        methods : {
            setType(type){
                this.type = type;
                system.postMessage(JSON.stringify({
                    active : this.active,
                    type : this.type
                }))
            }
        }
    }
</script>

<style lang="less">
    #active68{min-height:100%;background-color:#FB323A;overflow: auto;background-image: url("http://static.yuread.cn/quick/bg/1.png");background-repeat: no-repeat;background-size: 100% auto;
        .a{width: 100%;}
        .box{display: flex;width: 674px;height:534px;padding:150px 40px 0;justify-content: space-between;margin:660px auto 30px;background-image: url("http://static.yuread.cn/quick/bg/2.png");background-size: 100% 100%;
            .option{width: 288px;
                .pao{background-image: url("http://static.yuread.cn/quick/bg/4.png");background-size:100% auto;background-repeat:no-repeat;width: 130px;height: 60px;text-align: center;color: #fff;margin:0 auto;position: relative;}
                .info{width: 288px;height:296px;background-image: url("http://static.yuread.cn/quick/bg/3.png");background-size:100% 100%;background-repeat:no-repeat;margin-top: -38px;text-align: center;padding-top: 40px;
                    h3{font-size: 72px;color: #FD1B1F;
                        span{font-size: 40px;}
                    }
                    p{font-size: 24px;color: #BE7C43;margin: 10px 0;}
                    button{background: #FD1B1F;border: none;color:#FDF1B8; width: 180px;height: 52px;border-radius: 26px;margin-top: 30px;}
                }
            }
        }
        .box1{width: 668px;height: 556px;margin: 30px auto 80px;
            img{width: 100%;height: 100%;}
        }
        .tip{font-size: 24px;color: #fff;text-align: center;margin-top: 20px;}
        .type{
            background-color: rgba(0,0,0,.3);position: fixed;top:0;left:0;right:0;bottom:0;
            ul{ position:absolute;bottom:0;width: 100%;background-color: #fff;display: flex;justify-content: space-between;padding: 102px 40px 68px;border-radius: 58px 58px 0 0;
                li{width: 308px;height:86px;text-align: center;border-radius: 43px;color: #fff;font-size: 32px;line-height: 86px;}
                .wechat{background-color: #32BE1B;}
                .zfb{background-color: #1296db;}
                img{width: 34px;height:34px;position: relative;top:5px;}
            }
        }
    }
</style>
